import { render, staticRenderFns } from "./gamedialog.vue?vue&type=template&id=32c3a958&scoped=true"
import script from "./gamedialog.vue?vue&type=script&lang=js"
export * from "./gamedialog.vue?vue&type=script&lang=js"
import style0 from "./gamedialog.vue?vue&type=style&index=0&id=32c3a958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c3a958",
  null
  
)

export default component.exports